import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';

export default function Vendor() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const showModel = () => {
    document.body.classList.add("modal-open");
  };
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 vender-section">
                <div className="vender-heading">
                  <h4>Supported Languages</h4>
                  <p>Choose the language pairs that your company offers translations for.
                     Select the language pairs your are best with, and mark them as Top Language Pairs.</p>
				        </div>
              
                  <div className="support-lang-section flex">
                    <div className="support-lang-list">
                      <h6>Choose One Source Language</h6>
                      <div className="support-lang-wrap">
                        <ul className="choose-lang-btn">
                          <li>
                             <input type="checkbox" id="langChk1" />
                             <label for="langChk1">
                               Afrikaans
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk2" />
                             <label for="langChk2">
                                Albanian
                                <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                              </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk3" />
                             <label for="langChk3">Amharic
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk4" />
                             <label for="langChk4">Arabic (Algreria)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                           </li>
                          <li>
                             <input type="checkbox" id="langChk5" />
                             <label for="langChk5">Arabic (Bahrain)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk6" />
                             <label for="langChk6">Arabic (Egypt)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                         </li>
                          <li>
                             <input type="checkbox" id="langChk7" />
                             <label for="langChk7">Arabic
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="support-lang-list">
                      <h6>Choose Target Language</h6>
                      <div className="support-lang-wrap">
                        <ul className="choose-lang-btn">
                          <li>
                             <input type="checkbox" id="langChk8" checked/>
                             <label for="langlangChk8Chk1">
                               Afrikaans
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk9" />
                             <label for="langChk9">
                                Albanian
                                <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                              </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk10" />
                             <label for="langChk10">Amharic
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk11" />
                             <label for="langChk11">Arabic (Algreria)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                           </li>
                          <li>
                             <input type="checkbox" id="langChk12" />
                             <label for="langChk12">Arabic (Bahrain)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                          </li>
                          <li>
                             <input type="checkbox" id="langChk13" />
                             <label for="langChk13">Arabic (Egypt)
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                               </svg>
                             </label>
                         </li>
                          <li>
                             <input type="checkbox" id="langChk14" />
                             <label for="langChk14">Arabic
                               <svg className="greentick-icon" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                 <rect width="23" height="23" rx="11.5" fill="#52CE25"/>
                                 <path d="M16.3227 8.16129L10.2017 14.8387L7.41943 11.8035" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                             </label>
                          </li>
                         </ul>
                      </div>
                    </div>
                    <div className="support-lang-list">
                      <h6>Add the following Pairs</h6>
                      <div className="support-lang-wrap">
                        <div className="following-pairs">
                          <div className="source-language">
                            <span>Sourced Language</span>
                            <strong>Albanian</strong>
                          </div>
                          <div className="target-language">
                             <span>Targeted Languages:</span>
                             <ul>
                               <li className="flex-center justify-center">
                                 <strong>Arabic (Algreria)</strong>
                                 <button aria-label="delete icon">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                   <path d="M6.92498 3.2H10.075C10.075 2.78228 9.90904 2.38167 9.61367 2.0863C9.3183 1.79093 8.91769 1.625 8.49998 1.625C8.08226 1.625 7.68165 1.79093 7.38628 2.0863C7.09091 2.38167 6.92498 2.78228 6.92498 3.2ZM5.87498 3.2C5.87498 2.5038 6.15154 1.83612 6.64382 1.34384C7.1361 0.851559 7.80378 0.574997 8.49998 0.574997C9.19617 0.574997 9.86385 0.851559 10.3561 1.34384C10.8484 1.83612 11.125 2.5038 11.125 3.2H16.375C16.5142 3.2 16.6477 3.25531 16.7462 3.35377C16.8447 3.45222 16.9 3.58576 16.9 3.725C16.9 3.86424 16.8447 3.99777 16.7462 4.09623C16.6477 4.19468 16.5142 4.25 16.375 4.25H15.2683L14.0146 15.1112C13.926 15.8789 13.5582 16.5873 12.9812 17.1015C12.4043 17.6158 11.6584 17.8999 10.8856 17.9H6.11438C5.34153 17.8999 4.59567 17.6158 4.01872 17.1015C3.44177 16.5873 3.074 15.8789 2.98538 15.1112L1.73168 4.25H0.624976C0.485737 4.25 0.352201 4.19468 0.253745 4.09623C0.155288 3.99777 0.0999756 3.86424 0.0999756 3.725C0.0999756 3.58576 0.155288 3.45222 0.253745 3.35377C0.352201 3.25531 0.485737 3.2 0.624976 3.2H5.87498ZM4.02803 14.9915C4.08727 15.5033 4.33257 15.9754 4.71726 16.3181C5.10195 16.6608 5.59919 16.8501 6.11438 16.85H10.8856C11.4008 16.8501 11.898 16.6608 12.2827 16.3181C12.6674 15.9754 12.9127 15.5033 12.9719 14.9915L14.2109 4.25H2.78903L4.02803 14.9915ZM6.92498 6.875C7.06421 6.875 7.19775 6.93031 7.29621 7.02877C7.39466 7.12722 7.44998 7.26076 7.44998 7.4V13.7C7.44998 13.8392 7.39466 13.9728 7.29621 14.0712C7.19775 14.1697 7.06421 14.225 6.92498 14.225C6.78574 14.225 6.6522 14.1697 6.55374 14.0712C6.45529 13.9728 6.39998 13.8392 6.39998 13.7V7.4C6.39998 7.26076 6.45529 7.12722 6.55374 7.02877C6.6522 6.93031 6.78574 6.875 6.92498 6.875ZM10.6 7.4C10.6 7.26076 10.5447 7.12722 10.4462 7.02877C10.3477 6.93031 10.2142 6.875 10.075 6.875C9.93574 6.875 9.8022 6.93031 9.70374 7.02877C9.60529 7.12722 9.54998 7.26076 9.54998 7.4V13.7C9.54998 13.8392 9.60529 13.9728 9.70374 14.0712C9.8022 14.1697 9.93574 14.225 10.075 14.225C10.2142 14.225 10.3477 14.1697 10.4462 14.0712C10.5447 13.9728 10.6 13.8392 10.6 13.7V7.4Z" fill="#1D4ED8"/>
                                 </svg>
                                 </button>
                               </li>
                               <li className="flex-center justify-center">
                                 <strong>Arabic (Egypt)</strong>
                                 <button aria-label="delete icon">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                   <path d="M6.92498 3.2H10.075C10.075 2.78228 9.90904 2.38167 9.61367 2.0863C9.3183 1.79093 8.91769 1.625 8.49998 1.625C8.08226 1.625 7.68165 1.79093 7.38628 2.0863C7.09091 2.38167 6.92498 2.78228 6.92498 3.2ZM5.87498 3.2C5.87498 2.5038 6.15154 1.83612 6.64382 1.34384C7.1361 0.851559 7.80378 0.574997 8.49998 0.574997C9.19617 0.574997 9.86385 0.851559 10.3561 1.34384C10.8484 1.83612 11.125 2.5038 11.125 3.2H16.375C16.5142 3.2 16.6477 3.25531 16.7462 3.35377C16.8447 3.45222 16.9 3.58576 16.9 3.725C16.9 3.86424 16.8447 3.99777 16.7462 4.09623C16.6477 4.19468 16.5142 4.25 16.375 4.25H15.2683L14.0146 15.1112C13.926 15.8789 13.5582 16.5873 12.9812 17.1015C12.4043 17.6158 11.6584 17.8999 10.8856 17.9H6.11438C5.34153 17.8999 4.59567 17.6158 4.01872 17.1015C3.44177 16.5873 3.074 15.8789 2.98538 15.1112L1.73168 4.25H0.624976C0.485737 4.25 0.352201 4.19468 0.253745 4.09623C0.155288 3.99777 0.0999756 3.86424 0.0999756 3.725C0.0999756 3.58576 0.155288 3.45222 0.253745 3.35377C0.352201 3.25531 0.485737 3.2 0.624976 3.2H5.87498ZM4.02803 14.9915C4.08727 15.5033 4.33257 15.9754 4.71726 16.3181C5.10195 16.6608 5.59919 16.8501 6.11438 16.85H10.8856C11.4008 16.8501 11.898 16.6608 12.2827 16.3181C12.6674 15.9754 12.9127 15.5033 12.9719 14.9915L14.2109 4.25H2.78903L4.02803 14.9915ZM6.92498 6.875C7.06421 6.875 7.19775 6.93031 7.29621 7.02877C7.39466 7.12722 7.44998 7.26076 7.44998 7.4V13.7C7.44998 13.8392 7.39466 13.9728 7.29621 14.0712C7.19775 14.1697 7.06421 14.225 6.92498 14.225C6.78574 14.225 6.6522 14.1697 6.55374 14.0712C6.45529 13.9728 6.39998 13.8392 6.39998 13.7V7.4C6.39998 7.26076 6.45529 7.12722 6.55374 7.02877C6.6522 6.93031 6.78574 6.875 6.92498 6.875ZM10.6 7.4C10.6 7.26076 10.5447 7.12722 10.4462 7.02877C10.3477 6.93031 10.2142 6.875 10.075 6.875C9.93574 6.875 9.8022 6.93031 9.70374 7.02877C9.60529 7.12722 9.54998 7.26076 9.54998 7.4V13.7C9.54998 13.8392 9.60529 13.9728 9.70374 14.0712C9.8022 14.1697 9.93574 14.225 10.075 14.225C10.2142 14.225 10.3477 14.1697 10.4462 14.0712C10.5447 13.9728 10.6 13.8392 10.6 13.7V7.4Z" fill="#1D4ED8"/>
                                 </svg>
                                 </button>
                               </li>
                             </ul>
                          </div>
                        </div>
                        <button className="btn">Add Language Pair</button>
                      </div>
                    </div>
                    <div className="support-lang-list">
                      <h6>Current Language Pairs</h6>
                      <div className="support-lang-wrap">
                        <ul className="language-pair">
                          <li>
                            <strong>Afrikaans</strong>
                            <span>English, Dutch<small role="button" tabIndex="0" onClick={showModel}>4+</small></span>
                          </li>
                          <li>
                            <strong>Albanian</strong>
                            <span>Arabic (Algreria), Arabic (Egypt)<small role="button" tabIndex="0">4+</small></span>
                          </li>
                          <li>
                            <strong>Albanian</strong>
                            <span>Arabic (Algreria), Arabic (Egypt)<small role="button" tabIndex="0">4+</small></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                

                <div className="vender-heading">
                  <h4>Supported Languages</h4>
                  <p>Choose the language pairs that your company offers translations for.
                     Slecet the language pairs your are best with, and mark them as Top Language Pairs.</p>
				        </div>
                <div className="language-table-section flex">
                  <div className="language-table">
                     <h6>Select up to 10 Top Language Pairs</h6>
                     <div className="outer-border">
                        <div className="table-responsive global-table">
                            <table className="sortable">
                              <thead>
                                <th>Source Language</th>
                                <th>Target Language</th>
                                <th>Top Language Pair</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Albanian (Albania)</td>
                                  <td>Arabic</td>
                                  <td><button>Add</button></td>
                                </tr>
                                <tr>
                                  <td>Arabic (Algeria)</td>
                                  <td>Arabic</td>
                                  <td><button>Add</button></td>
                                </tr>
                                <tr>
                                  <td>Arabic (Algeria)</td>
                                  <td>Arabic</td>
                                  <td><button>Add</button></td>
                                </tr>
                                <tr>
                                  <td>Arabic (Algeria)</td>
                                  <td>Arabic (Lebanon)</td>
                                  <td><button>Add</button></td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                     </div>
                  </div>
                  <div className="language-table not-center-table">
                     <h6>Current Top Language Pairs</h6>
                     <div className="outer-border">
                        <div className="table-responsive global-table">
                            <table className="sortable">
                              <thead>
                                <th>Target Language</th>
                                <th>Source Language</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Afrikaans</td>
                                  <td>
                                    <span>English, Dutch</span>
                                    <small role="button" tabIndex="0">14+</small>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Albanian</td>
                                  <td>
                                    <span>Arabic (Algreria), Arabic (Egypt)</span>
                                    <small role="button" tabIndex="0">8+</small>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Arabic (Algeria)</td>
                                  <td>
                                    <span>Arabic (Algreria), Arabic (Egypt)</span>
                                    <small role="button" tabIndex="0">18+</small>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Arabic (Algeria)</td>
                                  <td>
                                    <span>Arabic (Algreria), Arabic (Egypt)</span>
                                    <small role="button" tabIndex="0">18+</small>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                     </div>
                  </div>
                </div>
            </div>
          </div>
        </section>
      </div>
      <div className="lightbox-panel target-lang-popup">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <strong>List of Target Languages</strong>
              <button className="close" aria-label="close right popup" onClick={hideModel}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
                <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
              </svg>
             </button>
             </div>
             <div className="lightbox-content">
               <div className="multiselect-output flex">
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Palestinian Territories)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Czech (Czech Republic)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Tunisia)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button>
                    <strong>Arabic (Palestinian Territories)</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                     <path d="M1.50586 8.49531L5.00119 4.99997M8.49653 1.50464L5.00053 4.99997M5.00053 4.99997L1.50586 1.50464M5.00119 4.99997L8.49653 8.49531" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                 </div>
             </div>	
             <div className="modal-footer modal-footer-border flex px-22">
                <button className="btn btn-bold active">Done</button>
              </div>
            </div>		
          </div>
    </div>
  );
}
